function getDifferenceBetweenDates(startDate, endDate) {
  const diffTime = Math.abs(endDate - startDate) + 1;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export default getDifferenceBetweenDates;
